import { useEffect, useState } from 'react';
import { once, run } from '../helper/electron';
import isElectron from '../utils/isElectron';

export type DjSoftwareId = 'serato' | 'virtualdj';

const request = <T>(channel: string, timeoutMs = 4000): Promise<T | null> =>
  new Promise((resolve) => {
    if (!isElectron()) {
      resolve(null);
      return;
    }
    const timer = window.setTimeout(() => resolve(null), timeoutMs);
    once(channel, (result: T) => {
      window.clearTimeout(timer);
      resolve(result);
    });
    run(channel);
  });

export const useDjSoftwareConnections = () => {
  const [connected, setConnected] = useState({
    serato: false,
    virtualdj: false,
  });

  useEffect(() => {
    let cancelled = false;

    const refresh = async () => {
      const [serato, virtualdj] = await Promise.all([
        request<{ success?: boolean; source?: string }>(
          'serato/get-library-info',
        ),
        request<{ available?: boolean }>('virtualdj/status'),
      ]);
      if (cancelled) return;
      setConnected({
        serato: !!serato?.success && serato.source !== 'missing',
        virtualdj: !!virtualdj?.available,
      });
    };

    void refresh();
    window.addEventListener('focus', refresh);
    const timer = window.setInterval(refresh, 8000);
    return () => {
      cancelled = true;
      window.removeEventListener('focus', refresh);
      window.clearInterval(timer);
    };
  }, []);

  return connected;
};
